  /* ============================================================
     ATM DIRECTORY EMBED — money-guide.html
     Pre-filtered to poi-atm. Same data layer as index.html.
     ============================================================ */

  const ATM_REGIONS = [
    { id: 'CR', label: 'Costa Rica' },
    { id: 'PJ', label: 'Jacó Beach' },
    { id: 'TA', label: 'Tamarindo' },
    { id: 'FA', label: 'Arenal & La Fortuna' },
    { id: 'MA', label: 'Manuel Antonio & Quepos' },
    { id: 'CH', label: 'Playas del Coco & Hermosa' },
    { id: 'DU', label: 'Costa Ballena' },
    { id: 'HE', label: 'Herradura Beach' },
  ];

  const ATM_CAT_ICON = {
    accom:'accomodation_icom.png', rest:'restaurante_icon.png',
    tour:'transport_icon.png', shop:'shopping_icon.png',
    'poi-beach':'beach_icon.png', 'poi-park':'park_icon.png',
    'poi-hospital':'hospital_icom.png', 'poi-police':'police_icon.png',
    'poi-atm':'atm_icon.png', 'poi-info':'info_icon.png',
    'poi-monument':'monument_icon.png', 'poi-museum':'museum_icon.png',
    'poi-church':'church_icon.png', default:'general_icon.png',
  };

  function _afv(v) { return Array.isArray(v) ? (v[0] ?? '') : (v ?? ''); }

  function _aCatKey(r) {
    const raw = String(_afv(r.poiCategory)||'').trim().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,' ').trim();
    const map = { hospital:'hospital', clinic:'hospital', policia:'police', police:'police',
      cajero:'atm', banco:'atm', atm:'atm', parque:'park', park:'park',
      playa:'beach', playas:'beach', beach:'beach', info:'info',
      monument:'monument', monumento:'monument', museo:'museum', museum:'museum',
      general:'general', iglesia:'church', church:'church', promo:'promo' };
    if (map[raw]) return `poi-${map[raw]}`;
    const isAct = v => { const s = String(_afv(v)||'').trim().toUpperCase(); return s==='1'||s==='TRUE'||s==='SI'; };
    if (isAct(r.Accom)) return 'accom';
    if (isAct(r.Rest))  return 'rest';
    if (isAct(r.Tour))  return 'tour';
    if (isAct(r.Shop))  return 'shop';
    return 'default';
  }

  function _aSafeStr(v) {
    const s = String(_afv(v)||'').trim();
    return (!s || /^[.\-]$/.test(s) || /^N\/?A$/i.test(s)) ? '' : s;
  }
  function _aSafeUrl(v) { const s = _aSafeStr(v); return s ? (/^https?:\/\//i.test(s) ? s : `https://${s}`) : ''; }
  function _aSafeEmail(v) { const s = String(_afv(v)||'').trim().replace(/\s+/g,''); return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s) ? s : ''; }

  function _aSanitize(html) {
    const src = String(html ?? '');
    if (!src.trim()) return '';
    if (!/<[^>]+>/.test(src)) return src.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\r?\n/g,'<br>');
    try {
      const doc = new DOMParser().parseFromString(`<div>${src}</div>`,'text/html');
      const wrap = doc.body.firstElementChild;
      const allowed = new Set(['B','STRONG','I','EM','U','BR','P','UL','OL','LI','A']);
      const walk = n => {
        if (n.nodeType===3) return doc.createTextNode(n.textContent||'');
        if (n.nodeType!==1) return null;
        const tag = n.tagName.toUpperCase();
        if (['SCRIPT','STYLE','IFRAME'].includes(tag)) return null;
        if (!allowed.has(tag)) { const f=doc.createDocumentFragment(); n.childNodes.forEach(c=>{const s=walk(c);if(s)f.appendChild(s);}); return f; }
        const el = doc.createElement(tag==='DIV'?'p':tag.toLowerCase());
        if (tag==='A') { const h=String(n.getAttribute('href')||'').trim(); if(h&&/^(https?:|mailto:|tel:)/i.test(h)){el.setAttribute('href',h);el.setAttribute('target','_blank');el.setAttribute('rel','noopener noreferrer');} }
        n.childNodes.forEach(c=>{const s=walk(c);if(s)el.appendChild(s);});
        return el;
      };
      const out = doc.createElement('div');
      wrap.childNodes.forEach(c=>{const s=walk(c);if(s)out.appendChild(s);});
      return out.innerHTML;
    } catch { return src; }
  }

  function _aAdaptRecord(record, mapaId) {
    const catKey = _aCatKey(record);
    const icon = ATM_CAT_ICON[catKey] || ATM_CAT_ICON.default;
    const phone = _aSafeStr(record.Tel1);
    const whatsapp = _aSafeStr(record.whatsapp);
    const email = _aSafeEmail(record.email || record.Email);
    const website = _aSafeUrl(record.WebLink);
    const gps = String(_afv(record.GPS)||'').trim();
    let waze='', gpsLat=null, gpsLon=null;
    if (gps) {
      const parts = gps.split(',');
      if (parts.length===2 && parts.every(p=>!isNaN(parseFloat(p.trim())))) {
        gpsLat = parseFloat(parts[0].trim()); gpsLon = parseFloat(parts[1].trim());
        waze = `https://waze.com/ul?ll=${gpsLat},${gpsLon}&navigate=yes`;
      }
    }
    const gmaps = _aSafeUrl(record.GmapLink) || (gpsLat && gpsLon ? `https://maps.google.com/?q=${gpsLat},${gpsLon}` : null);
    let hero = '';
    const artUrl = String(_afv(record.ArtworkUrl)||'').trim();
    if (artUrl && /^https?:\/\//i.test(artUrl)) {
      hero = artUrl.replace(/^https?:\/\/(www\.)?(staging\.crmaps\.com|crmaps\.com|localhost)(:\d+)?(?=\/|$)/i,'') || artUrl;
    } else {
      const artFile = String(_afv(record.Artwork)||'').trim();
      if (artFile && artFile!=='--' && artFile!=='.' && !artFile.includes('/') && /\.(jpe?g|png|webp|gif|avif)$/i.test(artFile))
        hero = `/imagenes/ads/${encodeURIComponent(artFile)}`;
    }
    const baseId = String(_afv(record.ClientID)||_afv(record.id)||'');
    const dupId  = String(_afv(record.__duplicateId)||'').trim();
    return {
      id: dupId ? `${baseId}::dup::${dupId}` : baseId,
      name: String(_afv(record.Company)||''),
      icon, hero, desc: String(_afv(record.description)||'').trim(),
      phone, whatsapp, email, website, gmaps, waze, gpsLat, gpsLon,
      _catKey: catKey, _mapaId: mapaId,
    };
  }

  async function _aLoadRegion(regionId) {
    const code = String(regionId||'').trim().toUpperCase();
    if (!code) return [];
    try {
      const res = await fetch(`/api/hotspots/${code}.json?_=${Math.floor(Date.now()/300000)}`, { cache:'no-store' });
      if (!res.ok) return [];
      const payload = await res.json();
      const records = Array.isArray(payload) ? payload
        : (payload && typeof payload==='object' && !payload.error ? Object.values(payload) : []);
      return records.filter(r=>r&&typeof r==='object'&&!Array.isArray(r)).map(r=>_aAdaptRecord(r,regionId));
    } catch { return []; }
  }

  /* ---- Component ---- */
  function AtmDirectory() {
    const [allHotspots, setAll] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [fetched, setFetched] = React.useState(false);
    const [selectedMap, setSelectedMap] = React.useState('all');
    const [selected, setSelected] = React.useState(null);
    const [mapOpen, setMapOpen] = React.useState(false);
    const [search, setSearch] = React.useState('');
    const [panelOpen, setPanelOpen] = React.useState(false);
    const mobilePanelRef = React.useRef(null);

    const [lang, setLang] = React.useState(() => document.documentElement.lang === 'es' ? 'es' : 'en');
    React.useEffect(() => {
      const handler = (e) => setLang(e.detail === 'es' ? 'es' : 'en');
      window.addEventListener('crmaps-lang-change', handler);
      return () => window.removeEventListener('crmaps-lang-change', handler);
    }, []);
    const c = lang === 'es' ? {
      btnMaps:'Región', allMaps:'Todas las regiones', searchPh:'Buscar cajero…',
      loading:'Cargando cajeros…', noResults:'No se encontraron cajeros.',
      emptyHint:'Selecciona un cajero para ver más detalles.', catLabel:'ATM',
      call:'Llamar', whatsapp:'WhatsApp', email:'Email', website:'Web',
      waze:'Waze', gmaps:'Maps', location:'Ubicación',
    } : {
      btnMaps:'Region', allMaps:'All regions', searchPh:'Search ATMs…',
      loading:'Loading ATMs…', noResults:'No ATMs found.',
      emptyHint:'Select an ATM to see details.', catLabel:'ATM',
      call:'Call', whatsapp:'WhatsApp', email:'Email', website:'Website',
      waze:'Waze', gmaps:'Maps', location:'Location',
    };

    React.useEffect(() => {
      if (fetched) return;
      setFetched(true); setLoading(true);
      Promise.all(ATM_REGIONS.map(r => _aLoadRegion(r.id))).then(results => {
        const flat = results.flat().filter(h => h._catKey === 'poi-atm' && h.name);
        const seen = new Set();
        const deduped = flat.filter(h => {
          const k = (h.name||'').trim().toLowerCase() + '\x00' + (h._mapaId||'');
          if (!k || seen.has(k)) return false;
          seen.add(k); return true;
        });
        setAll(deduped);
        if (deduped.length > 0) setSelected(deduped[0]);
        setLoading(false);
      });
    }, [fetched]);

    React.useEffect(() => {
      if (!mapOpen) return;
      const close = () => setMapOpen(false);
      document.addEventListener('mousedown', close);
      return () => document.removeEventListener('mousedown', close);
    }, [mapOpen]);

    React.useEffect(() => {
      if (!(panelOpen && selected)) return;
      if (!window.matchMedia('(max-width:767px)').matches) return;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }, [panelOpen, selected]);

    const afterMap = selectedMap === 'all'
      ? (() => { const s=new Set(); return allHotspots.filter(h=>{ const n=(h.name||'').trim().toLowerCase(); if(!n||s.has(n))return false; s.add(n); return true; }); })()
      : allHotspots.filter(h => h._mapaId === selectedMap);

    const filtered = afterMap.filter(h => !search || h.name.toLowerCase().includes(search.toLowerCase()));
    const selKey = selected ? `${selected._mapaId}:${selected.id}` : null;

    function PanelContent({ hs }) {
      const lat = hs.gpsLat, lon = hs.gpsLon, d = 0.008;
      const mapSrc = lat && lon
        ? `https://www.openstreetmap.org/export/embed.html?bbox=${lon-d},${lat-d},${lon+d},${lat+d}&layer=mapnik&marker=${lat},${lon}`
        : null;
      return (
        <>
          {hs.hero
            ? <div className="dir-panel-hero"><img src={hs.hero} alt={hs.name} /></div>
            : <div className="dir-panel-hero is-placeholder"><img src="/imagenes/icons/atm_icon.png" alt="" /></div>
          }
          <div className="dir-panel-meta">
            <div className="dir-panel-cat"><img src="/imagenes/icons/atm_icon.png" alt="" />{c.catLabel}</div>
            <div className="dir-panel-name">{hs.name}</div>
            {hs._mapaId && <div className="dir-panel-region">{ATM_REGIONS.find(r=>r.id===hs._mapaId)?.label||hs._mapaId}</div>}
          </div>
          <div className="dir-panel-body">
            {hs.desc && <div className="dir-panel-desc" dangerouslySetInnerHTML={{ __html: _aSanitize(hs.desc) }} />}
            <div className="dir-panel-actions">
              {hs.phone    && <a href={`tel:${hs.phone}`} className="dir-action-btn is-primary"><img src="/imagenes/icons/phone-icon.png" alt="" />{c.call}</a>}
              {hs.whatsapp && <a href={`https://wa.me/${hs.whatsapp.replace(/\D/g,'')}`} target="_blank" rel="noopener noreferrer" className="dir-action-btn"><img src="/imagenes/icons/whatsapp-icon.png" alt="" />{c.whatsapp}</a>}
              {hs.website  && <a href={hs.website} target="_blank" rel="noopener noreferrer" className="dir-action-btn"><img src="/imagenes/icons/web-icon.png" alt="" />{c.website}</a>}
              {hs.gmaps    && <a href={hs.gmaps} target="_blank" rel="noopener noreferrer" className="dir-action-btn"><img src="/imagenes/icons/Google-icon.png" alt="" />{c.gmaps}</a>}
              {hs.waze     && <a href={hs.waze} target="_blank" rel="noopener noreferrer" className="dir-action-btn" data-kind="waze"><img src="/imagenes/icons/waze-icon.png" alt="" />{c.waze}</a>}
              {hs.email    && <a href={`mailto:${hs.email}`} className="dir-action-btn"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>{c.email}</a>}
            </div>
            {mapSrc && (
              <>
                <div className="dir-panel-h">{c.location}</div>
                <div className="dir-panel-map">
                  <iframe key={hs.id} src={mapSrc} loading="lazy" title={hs.name} allowFullScreen />
                </div>
              </>
            )}
          </div>
        </>
      );
    }

    return (
      <>
        {/* Left: list */}
        <div className="dir-left">
          <div className="dir-controls">
            <div style={{ position:"relative", flexShrink:0 }}>
              <button className="dir-map-btn" onClick={e=>{ e.stopPropagation(); setMapOpen(o=>!o); }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg>
                {c.btnMaps}
                {selectedMap !== 'all' && <span style={{width:6,height:6,borderRadius:'50%',background:'#fff',flexShrink:0}} />}
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{transform:mapOpen?'rotate(180deg)':'none',transition:'transform 0.15s'}}><polyline points="6 9 12 15 18 9"/></svg>
              </button>
              {mapOpen && (
                <div className="dir-map-dropdown" onMouseDown={e=>e.stopPropagation()}>
                  <button className={`dir-map-item${selectedMap==='all'?' is-on':''}`} onClick={()=>{setSelectedMap('all');setMapOpen(false);}}>
                    {c.allMaps}{selectedMap==='all'&&<span>✓</span>}
                  </button>
                  {ATM_REGIONS.map(r=>(
                    <button key={r.id} className={`dir-map-item${selectedMap===r.id?' is-on':''}`} onClick={()=>{setSelectedMap(r.id);setMapOpen(false);}}>
                      {r.label}{selectedMap===r.id&&<span>✓</span>}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <input className="dir-search" type="search" placeholder={c.searchPh} value={search} onChange={e=>setSearch(e.target.value)} />
          </div>
          {fetched && !loading && selectedMap !== 'all' && (
            <div className="dir-status">{ATM_REGIONS.find(r=>r.id===selectedMap)?.label}</div>
          )}
          <div className="dir-list-wrap">
            <div className="dir-list">
              {loading && <div className="dir-loading">{c.loading}</div>}
              {!loading && fetched && filtered.length===0 && <div className="dir-loading">{c.noResults}</div>}
              {filtered.map(h => {
                const hKey = `${h._mapaId}:${h.id}`;
                return (
                  <button key={hKey} type="button" className={`dir-card${selKey===hKey?' is-active':''}`}
                    onClick={()=>{ setSelected(h); setPanelOpen(true); }}>
                    <div className="dir-card-thumb" style={h.hero?{backgroundImage:`url(${h.hero})`,backgroundSize:'cover',backgroundPosition:'center'}:{}}>
                      {!h.hero && <img src="/imagenes/icons/atm_icon.png" alt="" />}
                    </div>
                    <div className="dir-card-info">
                      <div className="dir-card-name">{h.name}</div>
                      <div className="dir-card-badge"><img src="/imagenes/icons/atm_icon.png" alt="" />{c.catLabel}</div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Right: detail panel (desktop) */}
        <div className="dir-panel">
          {!selected
            ? <div className="dir-panel-empty"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.35"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg><span>{c.emptyHint}</span></div>
            : <PanelContent hs={selected} />
          }
        </div>

        {/* Mobile slide-in — portal to body to escape stacking context */}
        {ReactDOM.createPortal(
          <>
            <div className={`atm-mobile-scrim${panelOpen&&selected?' is-open':''}`} onClick={()=>setPanelOpen(false)} />
            <div ref={mobilePanelRef} className={`atm-mobile-panel${panelOpen&&selected?' is-open':''}`}>
              <div className="atm-mp-scroll">
                {selected && (
                  <>
                    {selected.hero
                      ? <div className="dir-panel-hero">
                          <img src={selected.hero} alt={selected.name} />
                          <button className="atm-mobile-back" onClick={()=>setPanelOpen(false)} aria-label="Close">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                          </button>
                        </div>
                      : <div className="atm-mobile-noimg-bar">
                          <button className="atm-mobile-back" onClick={()=>setPanelOpen(false)} aria-label="Close">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                          </button>
                        </div>
                    }
                    <div className="dir-panel-meta">
                      <div className="dir-panel-cat"><img src="/imagenes/icons/atm_icon.png" alt="" />{c.catLabel}</div>
                      <div className="dir-panel-name">{selected.name}</div>
                      {selected._mapaId && <div className="dir-panel-region">{ATM_REGIONS.find(r=>r.id===selected._mapaId)?.label||selected._mapaId}</div>}
                    </div>
                    <div className="dir-panel-body">
                      {selected.desc && <div className="dir-panel-desc" dangerouslySetInnerHTML={{ __html: _aSanitize(selected.desc) }} />}
                      <div className="dir-panel-actions">
                        {selected.phone    && <a href={`tel:${selected.phone}`} className="dir-action-btn is-primary"><img src="/imagenes/icons/phone-icon.png" alt="" />{c.call}</a>}
                        {selected.whatsapp && <a href={`https://wa.me/${selected.whatsapp.replace(/\D/g,'')}`} target="_blank" rel="noopener noreferrer" className="dir-action-btn"><img src="/imagenes/icons/whatsapp-icon.png" alt="" />{c.whatsapp}</a>}
                        {selected.website  && <a href={selected.website} target="_blank" rel="noopener noreferrer" className="dir-action-btn"><img src="/imagenes/icons/web-icon.png" alt="" />{c.website}</a>}
                        {selected.gmaps    && <a href={selected.gmaps} target="_blank" rel="noopener noreferrer" className="dir-action-btn"><img src="/imagenes/icons/Google-icon.png" alt="" />{c.gmaps}</a>}
                        {selected.waze     && <a href={selected.waze} target="_blank" rel="noopener noreferrer" className="dir-action-btn" data-kind="waze"><img src="/imagenes/icons/waze-icon.png" alt="" />{c.waze}</a>}
                        {selected.email    && <a href={`mailto:${selected.email}`} className="dir-action-btn"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>{c.email}</a>}
                      </div>
                      {selected.gpsLat && selected.gpsLon && (() => {
                        const lat = selected.gpsLat, lon = selected.gpsLon, d = 0.008;
                        const src = `https://www.openstreetmap.org/export/embed.html?bbox=${lon-d},${lat-d},${lon+d},${lat+d}&layer=mapnik&marker=${lat},${lon}`;
                        return (
                          <>
                            <div className="dir-panel-h">{c.location}</div>
                            <div className="dir-panel-map">
                              <iframe key={`m-${selected.id}`} src={src} loading="lazy" title={selected.name} allowFullScreen />
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </>
                )}
              </div>
            </div>
          </>,
          document.body
        )}
      </>
    );
  }

  ReactDOM.createRoot(document.getElementById('atmDirRoot')).render(<AtmDirectory />);
  
